import { Route, Routes } from 'react-router-dom';
import PanelContainer from './Panels/PanelContainer';
import UserDetails from './Panels/UserDetails/UserDetails';

const AdminDetailsPanel = () => {
  return (
    <Routes>
      <Route
        path="users/:userEmail/*"
        element={
          <PanelContainer>
            <UserDetails />
          </PanelContainer>
        }
      />
    </Routes>
  );
};
export default AdminDetailsPanel;
